import React from "react";
import { Button, Checkbox, Col, DatePicker, Input, Row, Select, Upload } from "antd";
import { Controller, useFormContext } from "react-hook-form";
import UploadField from "../UploadField";
import { UploadOutlined } from "@ant-design/icons";
import Error from "./Error";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
const Payment = ({ paymentFields, addPayment, removePayment, propertyConfig, ocfDisplayId }) => {
  const {
    control, // ✅ important
    formState: { errors },
    watch,
  } = useFormContext();

  const colProps = { xs: 24, sm: 12, md: 12, lg: 8 };

  // (watch(`payment.${index}.paymentProof`) || watch(`payment.${index}.builderConfirmationFile`))
  return (
    <Row gutter={[16, 16]} style={{ margin: "28px 0" }}>
      <Col span={24} style={{ display: "flex", justifyContent: "space-between" }}>
        <h3>Payments</h3>

        <Button
          type="primary"
          onClick={() =>
            addPayment({
              type: "",
              amount: "",
              receiptNo: "",
              confirmation: false,
              date: "",
            })
          }
        >
          + Add More Payment
        </Button>
      </Col>

      {paymentFields.map((item, index) => (
        <React.Fragment key={item.id}>
          <Col span={24}>
            <div style={{ fontWeight: 600 }}>
              Payment #{index + 1}
              {index !== 0 &&
                !(
                  watch(`payment.${index}.paymentProof`)?.message ||
                  watch(`payment.${index}.builderConfirmationFile`)?.message
                ) && (
                  <Button
                    danger
                    size="small"
                    style={{ marginLeft: 12 }}
                    onClick={() => removePayment(index)}
                  >
                    Remove
                  </Button>
                )}
            </div>
          </Col>

          {/* Type */}
          <Col {...colProps}>
            <label>Payment Type</label>
            <Controller
              name={`payment.${index}.type`}
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  style={{ width: "100%" }}
                  placeholder="Select Payment confirmation"
                  status={errors.paymentType && "error"}
                >
                  {propertyConfig?.paymentType.map((type) => (
                    <Select.Option value={type} key={type}>
                      {type}
                    </Select.Option>
                  ))}
                </Select>
              )}
            />
            <Error name={`payment.${index}.type`} />
          </Col>

          <Col {...colProps}>
            <label>Payment Date</label>
            <Controller
              name={`payment.${index}.paymentDate`}
              control={control}
              render={({ field }) => (
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD-MM-YYYY"
                  value={field.value ? dayjs(field.value, "DD-MM-YYYY") : null}
                  onChange={(date, dateStr) => field.onChange(dateStr)}
                />
              )}
            />
            <Error name={`payment.${index}.paymentDate`} />
          </Col>

          {/* Amount */}
          <Col {...colProps}>
            <label>Amount</label>
            <Controller
              name={`payment.${index}.amount`}
              control={control}
              render={({ field }) => <Input {...field} placeholder="Amount" type="number" />}
            />
            <Error name={`payment.${index}.amount`} />
          </Col>

          {/* Receipt No */}
          <Col {...colProps}>
            <div className="form-field">
              <label className="form-label">Payment Details (Txn No/Cheque No)</label>
              <Controller
                name={`payment.${index}.receiptNo`}
                control={control}
                render={({ field }) => <Input {...field} placeholder="Payment Detail" />}
              />

              <Error name={`payment.${index}.receiptNo`} />
              <UploadField
                name={`payment.${index}.paymentProof`}
                fieldType={`paymentProof_${index + 1}`}
                label="Payment Proof File"
                ocfDisplayId={ocfDisplayId}
              />
              <Error name={`payment.${index}.paymentProof`} />
            </div>
          </Col>

          {/* Confirmation */}
          <Col {...colProps}>
            <label></label>
            <Controller
              name={`payment.${index}.confirmation`}
              control={control}
              render={({ field }) => (
                <Checkbox checked={field.value} onChange={(e) => field.onChange(e.target.checked)}>
                  Payment Confirmed
                </Checkbox>
              )}
            />
            <Error name={`payment.${index}.confirmation`} />
          </Col>

          {watch(`payment.${index}.confirmation`) && (
            <Col {...colProps}>
              <div className="form-field">
                <label className="form-label">Email Confirmation from Builder </label>

                <UploadField
                  name={`payment.${index}.builderConfirmationFile`}
                  fieldType={`builderConfirmationFile_${index + 1}`}
                  label="Email Confirmation File"
                  ocfDisplayId={ocfDisplayId}
                />
                <Error name={`payment.${index}.builderConfirmationFile`} />
              </div>
            </Col>
          )}
        </React.Fragment>
      ))}
    </Row>
  );
};

export default Payment;
